import VerifiedVehicles from '../../../../../pages/vip/features/verified-vehicles-tag/verified-vehicles-tag.desktop';

export default VerifiedVehicles;
